import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-play-filled-icon]',
  template: `
    <svg:path
      d="M4.99854 4.99855C4.99843 4.64674 5.09115 4.30114 5.26734 3.99663C5.44353 3.69212 5.69694 3.43949 6.002 3.26425C6.30705 3.089 6.65294 2.99735 7.00474 2.99855C7.35655 2.99974 7.70181 3.09374 8.00567 3.27105L19.9992 10.267C20.3019 10.4427 20.5532 10.6946 20.7279 10.9978C20.9027 11.301 20.9948 11.6447 20.9951 11.9947C20.9954 12.3446 20.9039 12.6885 20.7297 12.992C20.5554 13.2954 20.3046 13.5479 20.0022 13.724L8.00567 20.722C7.70181 20.8993 7.35655 20.9933 7.00474 20.9945C6.65294 20.9957 6.30705 20.904 6.002 20.7288C5.69694 20.5536 5.44353 20.3009 5.26734 19.9964C5.09115 19.6919 4.99843 19.3463 4.99854 18.9945V4.99855Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
    '[class]': 'extraClass()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayFilledIcon {
  readonly viewBox = input<string>('0 0 24 24');
  readonly extraClass = input<string>('');
}
